var React = require('react');

function IconChat (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":2})]));
}

IconChat.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconChat;

IconChat.default = IconChat;
